import script from "./Test.vue?vue&type=script&setup=true&lang=js"
export * from "./Test.vue?vue&type=script&setup=true&lang=js"

import "./Test.vue?vue&type=style&index=0&id=b250ddfc&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b250ddfc"]])

export default __exports__